import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import { api } from "../../../services/api";
import Swal from "sweetalert2";

export default function ModalImportacao({ show, onHide }) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [lookups, setLookups] = useState({ roteamentos: [], bandeiras: [], condicoes: [] });
    const [form, setForm] = useState({ roteamento: '', bandeira: '', condicao: '', taxa: 0 });

    useEffect(() => {
        if (show) {
            api.get('/financeiro/conciliacao/roteamentos')
                .then(res => setLookups(prev => ({ ...prev, roteamentos: res.data })))
                .catch(err => console.error("Erro ao carregar roteamentos", err));
        } else {
            setForm({ roteamento: '', bandeira: '', condicao: '', taxa: 0 });
            setData([]);
        }
    }, [show]);

    // --- FUNÇÃO AUXILIAR PARA BUSCAR CHAVES COM ACENTO (Ignora caracteres estranhos) ---
    const normalizar = (s) => {
        return String(s || '')
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, '')   // remove acentos
            .replace(/\?/g, '')                // remove caracteres quebrados
            .replace(/[^a-z0-9]/gi, '')        // remove símbolos
            .toLowerCase()
            .trim();
    };

    const getVal = (row, ...nomes) => {
        const keys = Object.keys(row);
        for (let nome of nomes) {
            const alvo = normalizar(nome);
            const key = keys.find(k => {
                const nk = normalizar(k);
                return (
                    nk === alvo ||          // match perfeito
                    nk.includes(alvo) ||   // coluna maior
                    alvo.includes(nk)      // nome maior
                );
            });
            if (key) return row[key];
        }
        return '';
    };

    const formatarDataBR = (valor) => {
        if (!valor) return '';

        // Caso venha nesse formato: Sat Jan 03 2026 00:00:00 GMT-0300
        if (typeof valor === 'string' && valor.includes('GMT')) {
            const d = new Date(valor);
            if (!isNaN(d)) {
                const dia = String(d.getDate()).padStart(2, '0');
                const mes = String(d.getMonth() + 1).padStart(2, '0');
                const ano = d.getFullYear();
                return `${dia}/${mes}/${ano}`;
            }
        }

        // Se for Date real
        if (valor instanceof Date) {
            const dia = String(valor.getDate()).padStart(2, '0');
            const mes = String(valor.getMonth() + 1).padStart(2, '0');
            const ano = valor.getFullYear();
            return `${dia}/${mes}/${ano}`;
        }

        const s = String(valor).trim();

        // formato DD/MM/YYYY
        if (/^\d{2}\/\d{2}\/\d{4}/.test(s)) {
            return s.substring(0, 10);
        }

        // formato ISO
        if (s.includes('-')) {
            const parts = s.split('T')[0].split('-');
            if (parts.length === 3) {
                const [y, m, d] = parts;
                return `${d}/${m}/${y}`;
            }
        }

        return s;
    };


    const formatarFloat = (valor) => {
        if (valor === undefined || valor === null || valor === '') return 0;
        let limpo = String(valor).replace(/\./g, '').replace(',', '.').replace(/"/g, '').trim();
        return parseFloat(limpo) || 0;
    };

    const handleRoteamento = async (val) => {
        setForm({ roteamento: val, bandeira: '', condicao: '', taxa: 0 });
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/bandeiras?roteamento=${val}`);
            setLookups(prev => ({ ...prev, bandeiras: ["Usar do arquivo", ...res.data], condicoes: [] }));
        } catch (err) {
            Swal.fire("Erro", "Erro ao buscar bandeiras", "error");
        }
    };

    const handleBandeira = async (val) => {
        setForm(prev => ({ ...prev, bandeira: val, condicao: '', taxa: 0 }));
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/condicoes?roteamento=${form.roteamento}&bandeira=${val}`);
            setLookups(prev => ({ ...prev, condicoes: res.data }));
        } catch (err) {
            console.error(err);
        }
    };

    const handleCondicao = async (val) => {
        setForm(prev => ({ ...prev, condicao: val }));
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/taxa?roteamento=${form.roteamento}&bandeira=${form.bandeira}&condicao=${val}`);
            setForm(prev => ({ ...prev, condicao: val, taxa: res.data.taxa || 0 }));
        } catch (err) {
            console.error(err);
        }
    };

    const handleFileUploadX = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (evt) => {
            const text = evt.target.result;
            // Lê como string para respeitar o encoding ISO-8859-1
            const wb = XLSX.read(text, { type: 'string', cellDates: false });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const json = XLSX.utils.sheet_to_json(ws, { raw: false });
            setData(json);
        };
        // AQUI ESTÁ O AJUSTE PARA ACENTOS BRASILEIROS
        reader.readAsText(file, "ISO-8859-1");
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (evt) => {

            // decodifica corretamente arquivos brasileiros
            const decoder = new TextDecoder("iso-8859-1");
            const text = decoder.decode(evt.target.result);

            const linhas = text.split(/\r?\n/).filter(l => l.trim() !== "");

            // cabeçalho
            const header = linhas[0].split(";").map(h => h.trim());

            const json = linhas.slice(1).map(linha => {
                const cols = linha.split(";");

                const obj = {};
                header.forEach((h, i) => {
                    obj[h] = cols[i] ? cols[i].replace(/"/g, "").trim() : "";
                });

                return obj;
            });

            setData(json);
        };

        reader.readAsArrayBuffer(file);
    };


    const handleSincronizar = async () => {
        if (!form.condicao || data.length === 0) {
            Swal.fire("Atenção", "Preencha todos os filtros e selecione o arquivo", "warning");
            return;
        }

        const getSafeCell = (row, index, ...names) => {
            // 1. Tenta buscar pelo nome exato (removendo espaços extras)
            const keys = Object.keys(row);
            for (const name of names) {
                const foundKey = keys.find(k => k.trim() === name);
                if (foundKey !== undefined) return row[foundKey];
            }

            // 2. Fallback: Se não achou pelo nome (devido a acentos corrompidos), 
            // usa o índice fixo da coluna baseado no arquivo SODEXO.csv
            const values = Object.values(row);
            return values[index] !== undefined ? values[index] : '';
        };

        setLoading(true);
        try {
            const payload = {
                taxa: form.taxa,
                itens: data.map(i => {
                    let bandeiraCalculada = form.bandeira;

                    if (form.bandeira === "Usar do arquivo") {
                        // tenta pegar por nome primeiro
                        let produtoArquivo =
                            getVal(i, 'Produto') ||
                            getVal(i, 'PRODUTO') ||
                            getVal(i, 'Produto ') ||
                            '';

                        // fallback BRUTO por posição da coluna (CSV Sodexo)
                        if (!produtoArquivo) {
                            const valores = Object.values(i);
                            produtoArquivo = valores[5] || ''; // coluna Produto no seu CSV
                        }

                        bandeiraCalculada = String(produtoArquivo).trim();
                    }
                    const values = Object.values(i);
                    const dataVenda = getVal(i, 'Data Venda') || values[3];
                    const dataCredito = values[7];
                    const dataCreditoOri = values[8];

                    return {
                        ROTEAMENTO: form.roteamento,
                        LOJA: parseInt(getSafeCell(i, 2, 'Loja') || 0),
                        DATAVENDA: formatarDataBR(getVal(i, 'Data Venda')),
                        BANDEIRA: bandeiraCalculada,
                        // Usando getVal para ignorar erro de acento em "Crédito"
                        DATACREDITO: formatarDataBR(dataCredito),

                        DATACREDORI: formatarDataBR(dataCreditoOri),
                        NUMCOMPROVANTE: String(
                            getVal(
                                i,
                                'Número Comprovante',
                                'Numero Comprovante',
                                'N?mero Comprovante',
                                'Nmero Comprovante',
                                'N?ero Comprovante',
                                'Comprovante'
                            )
                        ),
                        NSU: parseInt(getVal(i, 'NSU TEF') || getVal(i, 'NSU') || 0),
                        CODAUTORIZACAO: String(getVal(i, 'Autorização', 'Codigo Autorizacao', 'Autorizao')),
                        VALORBRUTO: formatarFloat(getVal(i, 'Valor Bruto')),
                        VALORCOMISSAO: formatarFloat(getVal(i, 'Valor Comissão', 'Valor Comissao','Valor Comiss?') || 0),
                        VALORLIQUIDO: formatarFloat(getVal(i, 'Valor Líquido', 'Valor lquido', 'Valor Liquido','Valor L?uido') || 0),
                        VALORLIQUIDOORIGINAL: formatarFloat(getVal(i, 'Valor Líquido Original', 'Valor Liquido Original', 'Valor Lquido Original', 'Valor L?uido Original') || 0),
                        PARCELA: parseInt(getVal(i, 'Parcela') || 1),
                        TOTALPARCELA: parseInt(getVal(i, 'Total de Parcelas') || 1),
                        CAPTURA: String(getVal(i, 'Captura') || ''),
                        TIPOLANCAMENTO: String(getVal(i, 'Tipo de Lançamento') || getVal(i, 'Tipo Lançamento') || ''),
                        DATAGERACAO: formatarDataBR(new Date()),
                        TAXAFLOR: form.bandeira === "Usar do arquivo" ? "USAR_ARQUIVO" : form.taxa,
                        CONDICAO: form.condicao
                    };
                })
            };

            await api.post('/financeiro/conciliacao/importar', payload);
            Swal.fire("Sucesso", "Importação realizada com sucesso!", "success");
            onHide();
        } catch (err) {
            const msgErro = err.response?.data?.erro || "Falha na comunicação com o servidor";
            Swal.fire("Erro na Importação", msgErro, "error");
        } finally {
            setLoading(false);
        }
    };

    const renderOptions = (lista, campo) => {
        return lista.map((item, index) => {
            const valor = typeof item === 'object' ? item[campo] : item;
            return <option key={index} value={valor}>{valor}</option>;
        });
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" centered backdrop="static">
            <Modal.Header closeButton className="bg-success text-white">
                <Modal.Title className="small fw-bold">IMPORTAÇÃO DE ARQUIVO DE CONCILIAÇÃO</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-light">
                <div className="card p-3 shadow-sm border-0 mb-3">
                    <div className="row g-2">
                        <div className="col-md-3">
                            <label className="small fw-bold">Roteamento</label>
                            <select className="form-select form-select-sm" value={form.roteamento} onChange={e => handleRoteamento(e.target.value)}>
                                <option value="">Selecione...</option>
                                {renderOptions(lookups.roteamentos, 'ROTEAMENTO')}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label className="small fw-bold">Bandeira</label>
                            <select className="form-select form-select-sm" value={form.bandeira} onChange={e => handleBandeira(e.target.value)}>
                                <option value="">Selecione...</option>
                                {renderOptions(lookups.bandeiras, 'BANDEIRA')}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label className="small fw-bold">Condição</label>
                            <select className="form-select form-select-sm" value={form.condicao} onChange={e => handleCondicao(e.target.value)}>
                                <option value="">Selecione...</option>
                                {renderOptions(lookups.condicoes, 'CONDICAO')}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label className="small fw-bold text-danger text-center w-100">Taxa do Roteamento</label>
                            <div className="form-control form-control-sm text-center fw-bold bg-white">
                                {form.taxa.toFixed(2)}%
                            </div>
                        </div>
                    </div>

                    <div className="mt-3">
                        <label className="small fw-bold">Selecionar Arquivo (CSV)</label>
                        <input type="file" className="form-control form-control-sm" accept=".csv" onChange={handleFileUpload} />
                    </div>
                </div>

                <div className="card shadow-sm border-0" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    <table className="table table-sm table-striped table-hover mb-0" style={{ fontSize: '0.7rem' }}>
                        <thead className="table-secondary sticky-top">
                            <tr>
                                {data.length > 0 && Object.keys(data[0]).map(k => <th key={k}>{k}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {data.slice(0, 50).map((row, i) => (
                                <tr key={i}>
                                    {Object.values(row).map((v, j) => <td key={j}>{String(v)}</td>)}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {data.length > 50 && <div className="text-center p-2 small text-muted">Exibindo apenas as primeiras 50 linhas para pré-visualização...</div>}
                </div>
            </Modal.Body>
            <Modal.Footer className="bg-white">
                <Button variant="secondary" size="sm" onClick={onHide} disabled={loading}>
                    CANCELAR
                </Button>
                <Button variant="success" size="sm" className="fw-bold" onClick={handleSincronizar} disabled={loading || data.length === 0}>
                    {loading ? 'PROCESSANDO...' : 'INICIAR IMPORTAÇÃO'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}